<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomViewsAPI from 'dashboard/api/customViews';
import SegmentPreview from './SegmentPreview.vue';

const emit = defineEmits(['result']);

// Seletor "Segmento" do publico de um disparo (Disparador, Broadcasts Pro e Flow): lista os segmentos de contatos que o
// usuario ve e mostra a previa do escolhido. `result` repassa a previa com o nome do segmento, para quem chama bloquear
// o envio quando ela responde erro.
const segmentId = defineModel({ type: Number, default: null });

const { t } = useI18n();

const segments = ref([]);
const selected = computed(() =>
  segments.value.find(segment => segment.id === segmentId.value)
);

const select = event => {
  segmentId.value = Number(event.target.value) || null;
  // Sem segmento a previa sai da tela; quem chama nao pode ficar com o resultado do anterior.
  if (!segmentId.value) emit('result', { valid: false, reachableCount: 0 });
};

const onResult = result => {
  emit('result', { ...result, name: selected.value?.name });
};

onMounted(async () => {
  const { data } = await CustomViewsAPI.getCustomViewsByFilterType('contact');
  segments.value = data;
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <label class="flex flex-col gap-1 text-sm text-n-slate-11">
      {{ t('DISPARADOR.SEGMENT_AUDIENCE.LABEL') }}
      <select
        :value="segmentId ?? ''"
        class="h-10 px-3 text-sm rounded-lg border border-n-weak bg-n-solid-1 text-n-slate-12"
        data-test="segment"
        @change="select"
      >
        <option value="">
          {{ t('DISPARADOR.SEGMENT_AUDIENCE.PLACEHOLDER') }}
        </option>
        <option
          v-for="segment in segments"
          :key="segment.id"
          :value="segment.id"
        >
          {{ segment.name }}
        </option>
      </select>
    </label>
    <p v-if="!segments.length" class="text-xs text-n-slate-10">
      {{ t('DISPARADOR.SEGMENT_AUDIENCE.EMPTY') }}
    </p>
    <SegmentPreview
      v-if="selected"
      :query="selected.query"
      @result="onResult"
    />
  </div>
</template>
